import { defineMessages } from 'react-intl'
import { Input } from 'antd'
import { debounce } from 'lodash'

import { ChangeEvent, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import ctgNameData from '../../data/ctgNameData'
import { StickerCategory } from '../../types'


const messages = defineMessages({
  placeholder: {
    id: 'EmojiSearchInputWindow.inputSearchText.placeholder',
    defaultMessage: 'Input search text.',
  },
})
type TagSearchInputProp = {
  everyStickerCategory: StickerCategory[]
  selectedCategory: number[]
  addEmojiCategory: (emojiIndex: StickerCategory) => void
}
export default function TagSearchInput({
  everyStickerCategory,
  selectedCategory,
  addEmojiCategory,
}: TagSearchInputProp) {
  const [input, setInput] = useState('')
  const [searchEmojiList, setsearchEmojiList] = useState<
    StickerCategory[] | null
  >([])

  const intl = useIntl()
  const findEmojiMatchToValue = async (value: string) => {
    const check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
    let searchEmojiList = []

    if (check.test(value)) {
      searchEmojiList = everyStickerCategory.filter((emojiCategory) => {
        for (const ko of emojiCategory.keytoken_ko) {
          if (ko.startsWith(value)) {
            return true
          }
        }
        return false
      })
    } else {
      searchEmojiList = everyStickerCategory.filter((emojiCategory) => {
        for (const en of emojiCategory.keytoken_en) {
          if (en.startsWith(value)) {
            return true
          }
        }
        return false
      })
    }
    // console.log(searchEmojiList)
    setsearchEmojiList(searchEmojiList.length === 0 ? null : searchEmojiList)
  }
  const wrapDebounceFindCategory = useMemo(
    () => debounce(findEmojiMatchToValue, 500),
    [],
  )

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value)
    wrapDebounceFindCategory(e.target.value)
  }

  return (
    <>
      <div>
        <div className="emotion-searchbar-wapper">
          <Input.Search
            placeholder={intl.formatMessage(messages.placeholder)}
            value={input}
            className="emotion-searchbar"
            onFocus={(e) => {
              wrapDebounceFindCategory(e.target.value)
            }}
            onChange={handleChange}
            onSearch={(value) => {
              // 포커스 이벤트 후에 search 이벤트가 발생하게끔 함
              setTimeout(() => {
                wrapDebounceFindCategory(value)
              }, 0)
            }}
            onBlur={() => {
              // setsearchEmojiList([])
            }}
          />
        </div>
      </div>
      <div className="search-emoji-list-wrapper">
        <div
          className="search-emoji-list-container"
          style={
            searchEmojiList?.length === 0
              ? {}
              : {
                  boxShadow: '0px 3px 15px #dddddd',
                  border: '1px solid #eeeeee',
                }
          }
        >
          {searchEmojiList === null && <div>No search results found</div>}
          {searchEmojiList !== null &&
            searchEmojiList.map((emojiCategory, index) => {
              const emjTitle = ctgNameData.find(
                (data) => data.emoji === emojiCategory.icon,
              )

              return (
                <div
                  className={
                    selectedCategory.includes(emojiCategory.index)
                      ? 'selected-search-emoji-item search-emoji-item'
                      : 'search-emoji-item'
                  }
                  onMouseDown={(event) => {
                    if (event.button === 0) {
                      addEmojiCategory(emojiCategory)
                    }
                  }}
                  key={index}
                >
                  <span
                    style={{
                      fontSize: 30,
                      margin: '5px 10px',
                      fontFamily: 'NotoColorEmoji',
                    }}
                  >
                    {emojiCategory.icon}
                  </span>
                  <p style={{ width: '100%', margin: 0 }}>
                    {intl.locale === 'ko' && emjTitle
                      ? emjTitle.name_ko
                      : emojiCategory.name}
                  </p>
                  <p
                    style={{
                      justifyContent: 'flex-end',
                      color: '#f55b60',
                      padding: '0px 10px',
                      fontSize: 25,
                      margin: 0,
                    }}
                  >
                    +
                  </p>
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}
